import { requestApi } from 'api/Api';

export const getLocationImportData = async (navigate, params) => {
  return requestApi({ url: '/api/practice_owner/get_location_data', params, navigate });
};
